/**
 * Mette "da" davanti al prezzo di un prodotto quando il prezzo mostrato è il più basso tra le varianti.
 * Il tema riscrive il prezzo a ogni cambio di variante: si controlla di nuovo ogni volta.
 * Se il prezzo contiene già il "da" (schede dei prodotti correlati), non si aggiunge una seconda volta.
 */
(() => {
  const normalizza = (testo) => testo.replace(/\s+/g, '').replace(/ /g, '');

  const aggiorna = (elemento) => {
    const minimo = elemento.dataset.customPrezzoMinimo;
    const prezzo = elemento.querySelector('[ref="priceContainer"] .price');
    if (!minimo || !prezzo) return;

    const attuale = normalizza(prezzo.textContent);
    if (attuale === normalizza(minimo)) {
      elemento.setAttribute('data-custom-da', '');
    } else {
      elemento.removeAttribute('data-custom-da');
    }
  };

  const avvia = (elemento) => {
    if (elemento.dataset.customDaAvviato) return;
    elemento.dataset.customDaAvviato = 'true';
    aggiorna(elemento);
    new MutationObserver(() => aggiorna(elemento)).observe(elemento, { childList: true, subtree: true, characterData: true });
  };

  const cerca = () => document.querySelectorAll('product-price[data-custom-prezzo-minimo]').forEach(avvia);

  cerca();
  document.addEventListener('DOMContentLoaded', cerca);
  new MutationObserver(cerca).observe(document.documentElement, { childList: true, subtree: true });
})();
